import SmokeFreeImg from "../../assets/img/smoke-free.jpg";
import LoseWeightImg from "../../assets/img/lose-weight.jpg";

//comment updated

export const Programmes = [
  {
    programmeId: "ffffffff-ffff-4fff-0001-000000000001",
    name: "Lose Weight",
    slug: "lose-weight",
    totalSteps: 13,
    tag: "loseWeight",
    features: {
      logWeight: true,
      bookAppointments: true,
      myProgress: true,
    },
    pillars: [
      {
        displayName: "Nutrition",
        tag: "eatWell",
      },
      {
        displayName: "Movement",
        tag: "moveMore",
      },
      {
        displayName: "Alcohol",
        tag: "drinkLess",
      },
      {
        displayName: "Mind",
        tag: "thinkHappy",
      },
      {
        displayName: "Sleep",
        tag: "sleepBetter",
      },
    ],
  },
  {
    programmeId: "ffffffff-ffff-4fff-0002-000000000001",
    name: "Smoke Free",
    slug: "smoke-free",
    totalSteps: 13,
    tag: "smokeFree",
    features: {
      logWeight: false,
      bookAppointments: false,
      myProgress: true,
    },
    pillars: [
      {
        displayName: "Nutrition",
        tag: "eatWell",
      },
      {
        displayName: "Movement",
        tag: "moveMore",
      },
      {
        displayName: "Alcohol",
        tag: "drinkLess",
      },
      {
        displayName: "Mind",
        tag: "thinkHappy",
      },
      {
        displayName: "Sleep",
        tag: "sleepBetter",
      },
      {
        displayName: "Smoking",
        tag: "smokeFree",
      },
    ],
  },
  {
    programmeId: "ffffffff-ffff-4fff-ffff-000000000001",
    name: "Sitting on Chairs",
    slug: "sitting-on-chairs",
    totalSteps: 3,
    tag: "sittingOnChairs",
    features: {
      logWeight: true,
      bookAppointments: true,
      myProgress: true,
    },
    pillars: [
      {
        displayName: "Nutrition",
        tag: "eatWell",
      },
      {
        displayName: "Movement",
        tag: "moveMore",
      },
      {
        displayName: "Alcohol",
        tag: "drinkLess",
      },
      {
        displayName: "Mind",
        tag: "thinkHappy",
      },
      {
        displayName: "Sleep",
        tag: "sleepBetter",
      },
    ],
  },
  {
    programmeId: "ffffffff-ffff-4fff-fffe-000000000001",
    name: "Standing on Tables",
    slug: "standing-on-tables",
    totalSteps: 2,
    tag: "standingOnTables",
    features: {
      logWeight: false,
      bookAppointments: false,
      myProgress: false,
    },
    pillars: [
      {
        displayName: "Nutrition",
        tag: "eatWell",
      },
      {
        displayName: "Movement",
        tag: "moveMore",
      },
      {
        displayName: "Alcohol",
        tag: "drinkLess",
      },
      {
        displayName: "Mind",
        tag: "thinkHappy",
      },
      {
        displayName: "Sleep",
        tag: "sleepBetter",
      },
      {
        displayName: "Smoking",
        tag: "smokeFree",
      },
    ],
  },
];

export const smokeFreeCardData = {
  programmeId: "ffffffff-ffff-4fff-0002-000000000001",
  primaryButtonUrl: "/sign-up/eligibility-checker/smoke-free",
  primaryButtonText: "Check Eligibility",
  secondaryButtonUrl: "/my-path/smoke-free/preview",
  programmeTitle: "Smoke free",
  cardTitle: "Time to go smoke free",
  description:
    "Discover a winning formula combining science and psychology to help you quit smoking for good with free quit aids, support, interactive videos and more.",
  imgUrl: SmokeFreeImg,
  imgTitle: "",
};

export const loseWeightCardData = {
  programmeId: "ffffffff-ffff-4fff-0001-000000000001",
  primaryButtonUrl: "/sign-up/eligibility-checker/lose-weight",
  primaryButtonText: "Check Eligibility",
  secondaryButtonUrl: "/my-path/lose-weight/preview",
  programmeTitle: "Lose Weight",
  cardTitle: "Time to lose weight",
  description:
    "Boost your health and lose weight with all the tools you need including 12 weeks of interactive videos, online articles, recipes, digital goodies and more.",
  imgUrl: LoseWeightImg,
  imgTitle: "",
};

export const loseWeightPageTitle = "Lose weight";

export const smokeFreePageTitle = "Smoke free";
